// accordionData.js

const accordionData = [
    {
      title: "What's Included",
      content: [
        "1000+ On-demand workouts",
        "Daily point earning and activity tracking",
        "Audio tracks and meditations",
        "Recipes and cook-along videos",
        "Personalized education programs",
        "Community and Leaderboard",
        "Registered Dietitian access",
      ],
    },
    {
      title: "Frequently Asked Questions",
      content: [
        {
          question: "What is included with my free trial to Treo Wellness?",
          answer: [
            "1000+ On-demand workouts on and off equipment",
            "Daily activity tracking with custom habit tiles",
            "100+ audio tracks for better sleep",
            "Meditations for mental health",
            "Recipes and cook-along videos for healthy eating",
            "Personalized education programs specific to your health goal",
            "Community, daily points, and monthly leaderboard",
            "Access to Certified Wellness Coaching for accountability",
            "Access to Registered Dietitian for a free 60 min consultation",
          ],
        },
        {
          question: "How long is the free trial for Treo Wellness?",
          answer: [
            "Treo Wellness offers a 30-day free trial with unlimited access to all of the content and features during the trial period. There is no credit card required at the time of free trial sign up.",
          ],
        },
        {
          question: "Is a credit card required to sign up?",
          answer: [
            "No, a credit card is not needed to sign up for the free 30-day trial. A card is only needed should you choose to become a subscriber at the end of the trial period.",
          ],
        },
        {
          question: "How much is a monthly subscription to Treo Wellness?",
          answer: [
            "After the 30-day trial period, Treo Wellness is just $7.99 a month and includes all of the great features listed above.",
          ],
        },
        {
          question: "How do you subscribe to Treo Wellness?",
          answer: [
            "When your 30-day trial period ends, your account will show a locked screen at your next log in. To subscribe, log into your Treo Wellness account on the web by visiting https://habit.treowellness.com. You will be prompted to complete the subscription account forms and add your payment information.",
          ],
        },
        {
          question: "Is it easy to cancel my subscription whenever I want?",
          answer: [
            "Yes. You will manage your monthly subscription by logging into your Treo Wellness account on the web at https://habit.treowellness.com. From the web, you will select the more menu from the bottom right navigation bar. Select ‘profile’ and then select ‘manage subscription’. You can update your payment card information, renew, or cancel your subscription at any time. If you cancel your subscription, you will retain access for the remainder of your current billing period. You will not be charged on the start of your next billing period and your access will be locked. You can still restart your subscription.",
          ],
        },
        {
          question: "Can I use Treo Wellness on my fitness equipment?",
          answer: [
            "Yes, we have on-demand workouts for treadmills, ellipticals, rowers, and more. Instructors cue to universal terms for resistance, speed, and incline. If you own Matrix Home Fitness products, check your app section of the touch screen console to login to your Treo Wellness account right on your equipment.",
          ],
        },
        {
          question: "What if I need help?",
          answer: [
            "For any support needs, please email support@treowellness.com. We monitor the support inbox Monday – Friday 8AM CST – 5PM CST. Questions will be answered in the order they are received.",
          ],
        },
      ],
    },
  ];
  
  export default accordionData;
  